<template>
  <div>
    <b-container fluid>
      <!-- User Interface controls -->
      <b-row>
        <b-col
          sm="4"
          md="4"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        striped
        hover
        small
        class="text-center"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :busy="loading"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(package)="row">
          {{ row.item.memberpackage.package.type }}
          {{ row.item.memberpackage.package.duration }}
        </template>
        <template v-slot:cell(purchase.sale_date)="data">
          {{ getFormatDateDisplay(data.value) }}
        </template>

        <template v-slot:cell(cycle)="row">
          {{ row.item.paid }} / {{ row.item.total }}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
            @click="unlocksubModal(row.item.id)"
            v-if="row.item.purchase == null"
          ><i class="fas fa-lock"></i>
          </b-button>

          <i
            v-else
            class="fas fa-dollar-sign ispaid"
          ></i>
        </template>
      </b-table>
    </b-container>
    <div>
      <b-modal
        id="cf-modal"
        title="Comfirm"
        @ok="handleOk"
      >
        <p class="my-4">Confirm Paid Subscription?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { formatDateDisplay } from "./../js/utils/date.js";
export default {
  props: { memberid: Number },
  data() {
    return {
      loading: false,
      fields: [
        {
          key: "memberpackage_id",
          label: "MP ID"
        },
        {
          key: "package",
          label: "Package"
        },
        /*{
          key: "memberpackage.package.fullname",
          label: "Package"
        },
        {
          key: "memberpackage.activate_date",
          label: "Activate Date"
        },*/
        /*{
          key: "paid",
          label: "Cycle"
        },
        {
          key: "total",
          label: "Total"
        },*/
        {
          key: "cycle",
          label: "Cycle"
        },
        {
          key: "purchase.price_total",
          label: "Price"
        },
        {
          key: "purchase.sale_date",
          label: "Sale Date"
        },
        {
          key: "purchase.ref_number",
          label: "Sale #"
        },
        {
          key: "actions",
          label: "Paid"
        }
      ],
      items: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [100, 200],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      currentSubId: null
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.unlockSubscription();
    },

    unlocksubModal(id) {
      this.currentSubId = id;
      this.$bvModal.show("cf-modal");
    },
    async unlockSubscription() {
      this.loading = true;
      await axios
        .post("/api/subscriptions/paid", {
          id: this.currentSubId
        })
        .then(response => {
          this.currentSubId = null;
          this.getData();
        })
        .catch(error => {})
        .finally(() => {
          this.$bvModal.hide("cf-modal");
          this.loading = false;
        });
    },
    async getData() {
      this.loading = true;
      await axios
        .get("/api/members/subscription/" + this.memberid)
        .then(response => {
          //console.log(response.data);

          this.items = response.data;
          this.totalRows = this.items.length;
        })
        .catch(error => {})
        .finally(() => (this.loading = false));
    },

    getFormatDateDisplay(date) {
      if (date == "") {
        return "-";
      }
      return formatDateDisplay(date);
    }
  }
};
</script>
<style scoped>
.ispaid {
  font-size: 2em;
  color: green;
}
</style>
